import { Button, ButtonGroup } from 'reactstrap';

import { useFilter } from './useFilter';

function Choice(props) {
    const filter = useFilter(
        props,
        () => {
            bindValue(props.context.getFilterValue(props.name));
        },
        handleClear
    );

    const { options, context } = props;
    const { value, setValue, handleToggle, setFilterValue, renderMenuButtons } = filter;

    const handleClear = () => {
        context.setFilterValue(props.name, null);
        setValue(null);
    };

    const handleCancel = () => {
        handleToggle();
    };

    const handleChoiceChange = option => {
        if (!option) {
            setValue(null);
            return;
        }

        setValue({ value: option, label: option.label });
        setFilterValue(props.name, option.value);
        handleToggle();
    };

    const bindValue = val => {
        const foundOption = options.find(option => option.value == val);

        if (foundOption) {
            setValue({ value: foundOption, label: foundOption.label });
        }
    };

    return filter.render(
        <div
            className="searchable-list-filter-menu"
            style={{
                padding: '10px',
                minWidth: '300px'
            }}
        >
            <div
                style={{
                    marginBottom: '1rem'
                }}
            >
                <ButtonGroup size="sm">
                    {options.map((option, optionIndex) => {
                        const isChoice = value && value.value.value == option.value ? true : false;

                        return (
                            <Button
                                key={optionIndex}
                                color={isChoice ? 'info' : 'secondary'}
                                outline={isChoice ? false : true}
                                onClick={() => {
                                    handleChoiceChange(option);
                                }}
                            >
                                {option.label}
                            </Button>
                        );
                    })}
                </ButtonGroup>
            </div>
            {renderMenuButtons({ handleCancel, handleClear })}
        </div>
    );
}

export default Choice;
